interface TabOptions {
	container: string | HTMLElement;
	tabButtons: string;
	tabBody: string;
	activeClass?: string;
}

export default class Tab {
	private container: HTMLElement;
	private tabButtons: NodeListOf<HTMLElement>;
	private tabBodies: NodeListOf<HTMLElement>;
	private activeClass: string;

	constructor({ container, tabButtons, tabBody, activeClass = 'active' }: TabOptions) {
		this.container = typeof container === 'string' 
			? document.querySelector(container) as HTMLElement
			: container;
		
		if (!this.container) {
			throw new Error('Container element not found');
		}

		this.tabButtons = this.container.querySelectorAll(tabButtons);
		this.tabBodies = this.container.querySelectorAll(tabBody);
		this.activeClass = activeClass;

		this.init();
	}

	private init(): void {
		this.tabButtons.forEach((button: HTMLElement) => {
			button.addEventListener('click', () => {
				const targetId = button.getAttribute('data-show');
				if (targetId) {
					this.showTab(targetId);
				}
			});
		});

		const firstButton = this.tabButtons[0];
		if (firstButton) {
			const targetId = firstButton.getAttribute('data-show');
			if (targetId) {
				this.showTab(targetId);
			}
		}
	}

	public showTab(targetId: string | null): void {
		if (!targetId || !this.tabBodies.length || !this.tabButtons.length) return;

		this.tabButtons.forEach((button: HTMLElement) => {
			button.classList.remove(this.activeClass);
		});
		this.tabBodies.forEach((body: HTMLElement) => {
			body.classList.remove(this.activeClass);
		});

		const activeButton = [...this.tabButtons].find(
			(btn: HTMLElement) => btn.getAttribute('data-show') === targetId
		);
		const activeBody = [...this.tabBodies].find(
			(body: HTMLElement) => body.getAttribute('data-id') === targetId
		);

		if (activeButton) activeButton.classList.add(this.activeClass);
		if (activeBody) activeBody.classList.add(this.activeClass);
	}
}
